var m = require('mithril');
var Model = require('../../libs/Model');
var headingElement = require('../../components/heading');
var Point = require('../models/point');
var buttonElement = require('../../components/button');

var customResource = Object.create(Model);
customResource.name = 'BacnetResource';
customResource['@class'] = 'Resource';
customResource.url = 'resource';
customResource.fields = {
  bacnetWritePriority: { default: null }
};

// Define BACnet priority options (1 highest → 16 lowest) with standard descriptions
const priorityOptions = [
  { level: 1, desc: 'Manual Life Safety – suggested for FSCS overrides' },
  { level: 2, desc: 'Automatic Life Safety – suggested for automated fire alarm response' },
  { level: 3, desc: 'Automated Self-Test – recommended for weekly self-test processes' },
  { level: 4, desc: 'Unreserved' },
  { level: 5, desc: 'Critical Equipment Control – suggested priority' },
  { level: 6, desc: 'Minimum On/Off – reserved for timer-based algorithms (read-only)' },
  { level: 7, desc: 'Unreserved' },
  { level: 8, desc: 'Manual Operator – suggested priority' },
  { level: 9, desc: 'Unreserved' },
  { level: 10, desc: 'Unreserved' },
  { level: 11, desc: 'Unreserved' },
  { level: 12, desc: 'Unreserved' },
  { level: 13, desc: 'Unreserved' },
  { level: 14, desc: 'Unreserved' },
  { level: 15, desc: 'Unreserved' },
  { level: 16, desc: 'Default/Relinquish – system default when all commands are NULL' }
];

customResource.initForm();


customResource.view =  function(vnode) {
  return m('div', [
    m(headingElement, {label: "BACnet Write Priority"}),
    m('form', [
    m('div.mb2', [
        m('select', {
        onchange: function(ev) { customResource.form.bacnetWritePriority(ev.target.value); },
        value: customResource.form.bacnetWritePriority()
        }, [
        m('option', {value: ''}, 'Select priority'),
        priorityOptions.map(function(opt) {
            return m('option', {value: opt.level}, opt.level + ' (' + opt.desc + ')');
        })
        ])
    ]),
    Point.errorView(),
    m('div.fr', [
        m(buttonElement, {
        label: 'Submit',
        func: customResource.save.bind(customResource),
        class: 'w4 fr'
        })
    ])
    ])
  ]);
}

module.exports = customResource;
